var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 306.53 308.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #1d1d1b;\n      }\n\n      .cls-2 {\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1b",
    "data-name": "1b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.3 157.3 81.3 157.3 0 116.64 0 308.13 78.71 308.13 81.29 308.13 81.29 165.79 81.29 157.29 81.3 157.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.72 175.51 117.72 175.51 117.72 183.66 117.72 308.13 153.15 308.13 153.16 193.23 117.72 175.51"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "159.79 174.07 159.79 73.82 306.53 .2 306.53 101.44 159.79 176.63 159.79 75.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "225.03 157.3 225.03 157.3 306.36 116.64 306.36 308.13 227.63 308.13 225.04 308.13 225.04 165.79 225.04 157.29 225.03 157.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.6 175.51 188.6 175.51 188.6 183.66 188.6 308.13 153.16 308.13 153.15 193.24 188.6 175.51"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "146.91 174.07 146.91 73.82 .16 .2 .16 101.44 146.91 176.63 146.91 75.78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsLogo);
export default __webpack_public_path__ + "static/media/MS-logo.6b683275557d427c7381e7cfbd2ca4ba.svg";
export { ForwardRef as ReactComponent };